module.exports = __webpack_public_path__ + "img/found.c610e463.svg";